<label>Choose the site tree view:</label>
<mat-radio-group
  [(ngModel)]="selectedView">
  @for (view of availableViews; track view) {
    <mat-radio-button [value]="view">{{view}}</mat-radio-button>
  }
</mat-radio-group>

<site-location-tree [hidden]="selectedView !== 'Location tree'" [siteId]="siteId"></site-location-tree>

<site-product-tree [style.display]="selectedView === 'Product tree' ? 'flex' : 'none'" [siteId]="siteId"></site-product-tree>